export const TRIGGER_SOURCE = {
  AUTO_WEBHOOK: 'auto_webhook',
  GITHUB_COMMENT: 'github_comment',
  CHECK_RUN: 'check_run',
  UI_MANUAL: 'ui_manual',
  MCP: 'mcp',
  TOP_UP_PAYMENT_RETRY: 'top_up_payment_retry',
} as const;

export type TriggerReviewSource = (typeof TRIGGER_SOURCE)[keyof typeof TRIGGER_SOURCE];

export const TRIGGER_SOURCE_VALUES = new Set<string>(Object.values(TRIGGER_SOURCE));

const EXPLICIT_USER_REVIEW_TRIGGER_SOURCES = new Set<TriggerReviewSource>([
  TRIGGER_SOURCE.UI_MANUAL,
  TRIGGER_SOURCE.GITHUB_COMMENT,
  TRIGGER_SOURCE.CHECK_RUN,
  TRIGGER_SOURCE.MCP,
]);

export function isExplicitUserReviewTrigger(
  triggerSource: TriggerReviewSource | null | undefined,
): boolean {
  return triggerSource != null && EXPLICIT_USER_REVIEW_TRIGGER_SOURCES.has(triggerSource);
}
